import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "33",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M16.605 3.355c-6.392 0-11.646 4.884-12.158 11.112H3.166a1 1 0 0 0-.704 1.71l2.24 2.222a1 1 0 0 0 1.408 0l2.24-2.222a1 1 0 0 0-.704-1.71h-1.19c.505-5.11 4.85-9.112 10.149-9.112a10.21 10.21 0 0 1 8.715 4.858 1 1 0 0 0 1.704-1.048 12.21 12.21 0 0 0-10.42-5.81"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      d: "M28.288 14.31a1 1 0 0 0-1.406 0l-2.248 2.222a1 1 0 0 0 .703 1.712h1.198c-.508 5.106-4.867 9.11-10.192 9.11-3.71 0-6.955-1.945-8.753-4.858a1 1 0 1 0-1.702 1.05 12.26 12.26 0 0 0 10.455 5.809c6.411 0 11.687-4.881 12.2-11.111h1.29a1 1 0 0 0 .703-1.712z",
      opacity: ".5"
    }, null, -1)
  ])))
}
export default { render: render }